export default "__VITE_ASSET__dibA4vCI__"